import React, { FC } from "react";
import { AppBar, Container, Toolbar } from "@mui/material";

const Header: FC = () => {
  return (
    <>
      <AppBar position="static" sx={{ backgroundColor: "#fff" }}>
        <Container maxWidth="xl">
          <Toolbar disableGutters>
            <img className="logo" alt={"Coop Logo"} />
          </Toolbar>
        </Container>
      </AppBar>
    </>
  );
};

export default Header;
